import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { Router } from "@angular/router";
import {
  NbComponentStatus,
  NbDialogService,
  NbGlobalPhysicalPosition,
  NbToastrService,
} from "@nebular/theme";

import { ProductService } from "../../services/product.service";

import { UserService } from "../../@core/services/user.service";
import { User } from "../../@core/data/users";
import { map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

import * as _ from "lodash";
import { LocalDataSource } from "ng2-smart-table";
import { StbCustomRenderNumberComponent } from "../smart-table-customs/custom-render-number";

@Component({
  selector: "ngx-view-table-receipt-employees",
  styleUrls: ["./view-table-receipt-employees.component.scss"],
  templateUrl: "./view-table-receipt-employees.component.html",
})
export class ViewTableReceiptEmployeesComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shopId?: string = "";
  @Input() language?: string = "";
  @Output() onSelectedItem: EventEmitter<any> = new EventEmitter();

  loading = false;
  submitted = false;
  isEditing = false;

  strSearch = "";
  uid = "anonymous";

  //ng2-smart-table config
  @Input() source: LocalDataSource = new LocalDataSource();
  // settings: any;
  settings = {
    hideHeader: false,
    noDataMessage: "",
    attr: {
      class: "table table-striped",
    },
    actions: {
      columnTitle: "",
      add: false,
      edit: false,
      delete: false,
    },
    columns: {},
  };

  constructor(private userService: UserService) {}

  ngOnInit(): void {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;

          if (!this.shopId || this.shopId == "") {
            this.shopId = user.shopId;
          }
          this.settings = {
            hideHeader: false,
            noDataMessage:
              user.language == "en" ? "Empty data" : "Không có dữ liệu",
            attr: {
              class: "table table-striped",
            },
            actions: {
              columnTitle: "",
              add: false,
              edit: false,
              delete: false,
            },
            columns: {
              employeeSaleName: {
                title: user.language == "en" ? "Employee Name" : "Nhân viên",
                type: "string",
              },
              totalQuantity: {
                title: user.language == "en" ? "Quantity" : "SL",
                width: "100px",
                filter: false,
                type: "custom",
                renderComponent: StbCustomRenderNumberComponent,
              },
              totalAmount: {
                title: user.language == "en" ? "Sale Amount" : "Tiền bán",
                width: "100px",
                filter: false,
                type: "custom",
                renderComponent: StbCustomRenderNumberComponent,
              },
              totalCostAmount: {
                title: user.language == "en" ? "Cost Amount" : "Tiền mua",
                width: "100px",
                filter: false,
                type: "custom",
                renderComponent: StbCustomRenderNumberComponent,
              },
              totalProfit: {
                title: user.language == "en" ? "Profit" : "Lãi gộp",
                width: "100px",
                filter: false,
                type: "custom",
                renderComponent: StbCustomRenderNumberComponent,
              },
            },
          };
        } else {
          this.uid = "anonymous";
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  //smart-table events
  selectedItem(event): void {
    const item = event.data;
    this.onSelectedItem.emit(item);
  }
}
